import { render, staticRenderFns } from "./todoList.vue?vue&type=template&id=3a2f0262&"
import script from "./todoList.vue?vue&type=script&lang=js&"
export * from "./todoList.vue?vue&type=script&lang=js&"
import style0 from "./todoList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports